import { Attachment } from "../types/ApiTypes";

export function getAttachmentDownloadUrl(attachment: Attachment) {
  return `https://storage.googleapis.com/wof-attachments/${attachment.name}`;
}
